import { useCall } from '../context/CallContext';
import UserAvatar from './UserAvatar';
import { Phone, PhoneOff, Video } from 'lucide-react';

export default function IncomingCallModal() {
  const { incomingCall, acceptCall, declineCall } = useCall();

  if (!incomingCall) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/70 backdrop-blur-sm" data-testid="incoming-call-modal">
      <div className="bg-card border rounded-2xl p-8 w-80 text-center shadow-2xl animate-in fade-in zoom-in-95 duration-300">
        {/* Pulsing ring indicator */}
        <div className="relative mx-auto w-24 h-24 mb-6">
          <div className="absolute inset-0 rounded-full bg-green-500/20 animate-ping" />
          <div className="absolute inset-2 rounded-full bg-green-500/10 animate-pulse" />
          <div className="relative z-10 flex items-center justify-center w-full h-full">
            <UserAvatar
              src={incomingCall.callerAvatar}
              name={incomingCall.callerName || 'Caller'}
              size="lg"
            />
          </div>
        </div>

        <h3 className="text-lg font-semibold mb-1" data-testid="caller-name">
          {incomingCall.callerName}
        </h3>
        <p className="text-sm text-muted-foreground mb-8" data-testid="call-type-label">
          Incoming {incomingCall.callType === 'video' ? 'video' : 'voice'} call...
        </p>

        <div className="flex items-center justify-center gap-8">
          {/* Decline */}
          <button
            onClick={declineCall}
            className="w-16 h-16 rounded-full bg-red-500 hover:bg-red-600 flex items-center justify-center text-white transition-all hover:scale-105 active:scale-95 shadow-lg shadow-red-500/30"
            data-testid="decline-call-btn"
          >
            <PhoneOff className="w-7 h-7" />
          </button>

          {/* Accept */}
          <button
            onClick={acceptCall}
            className="w-16 h-16 rounded-full bg-green-500 hover:bg-green-600 flex items-center justify-center text-white transition-all hover:scale-105 active:scale-95 shadow-lg shadow-green-500/30"
            data-testid="accept-call-btn"
          >
            {incomingCall.callType === 'video' ? (
              <Video className="w-7 h-7" />
            ) : (
              <Phone className="w-7 h-7" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
